<p-dialog
  [visible]="isVisible"
  (visibleChange)="onVisibleChange($event)"
  [showHeader]="false"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '1180px', maxWidth: '95vw' }"
  [baseZIndex]="1000000"
  styleClass="fuo-dialog noHeader">
  <div class="fuo-page">
    <!-- Header -->
    <div class="fuo-header">
      <div>
        <p class="fuo-header__title">Customise Follow Ups</p>
        <p class="fuo-header__sub">Choose the quick follow up options that appear in the follow up menu and set your preferred time for each.</p>
      </div>
      <div class="fuo-header__actions">
        <button type="button" class="_outline-primary-btn" (click)="resetToDefault()">
          <i class="pi pi-refresh mr-2 f-10"></i>
          Reset to default
        </button>
        <button type="button" class="_primary-btn" (click)="save()">
          <i class="pi mr-2 f-10" [ngClass]="isSaving ? 'pi-spin pi-spinner' : 'pi-save'"></i>
          {{ isSaving ? 'Saving...' : 'Save changes' }}
        </button>
        <button type="button" class="fuo-close" pTooltip="Close" tooltipPosition="left" (click)="close()">
          <i class="pi pi-times f-12"></i>
        </button>
      </div>
    </div>

    <div class="fuo-layout">
      <!-- Options editor -->
      <div class="fuo-card">
        <div class="fuo-card__head">
          <div>
            <p class="fuo-card__title">Your follow up options</p>
            <p class="fuo-card__sub">Enable, reorder and customise the days and times that work best for you.</p>
          </div>
          <button type="button" class="_outline-primary-btn" (click)="focusCustomForm()">
            <i class="pi pi-plus mr-2 f-10"></i>
            Add custom option
          </button>
        </div>

        <div class="fuo-table">
          <div class="fuo-row fuo-row--head">
            <span></span>
            <span>Show in menu</span>
            <span>Option label</span>
            <span>When it sets</span>
            <span>Default time</span>
            <span class="text-center">Actions</span>
          </div>

          <div class="fuo-empty" *ngIf="isLoading"><i class="pi pi-spin pi-spinner mr-2"></i>Loading...</div>
          <div class="fuo-empty" *ngIf="!isLoading && !options.length">
            No quick options — only "Pick date & time" will show in the follow up menu.
          </div>

          <div cdkDropList cdkDropListLockAxis="y" (cdkDropListDropped)="drop($event)">
            <div class="fuo-row" *ngFor="let option of options; trackBy: trackById" cdkDrag [class.fuo-row--off]="!option.isEnabled">
              <span class="fuo-grip" cdkDragHandle pTooltip="Drag to reorder" tooltipPosition="top">
                <i class="pi pi-ellipsis-v"></i>
                <i class="pi pi-ellipsis-v"></i>
              </span>
              <span>
                <p-inputSwitch [(ngModel)]="option.isEnabled" (onChange)="onOptionChange()"></p-inputSwitch>
              </span>
              <span>
                <input
                  type="text"
                  placeholder="Option label"
                  [maxlength]="labelMaxLength"
                  [class.invalidField]="submitted && !option.label?.trim()"
                  [(ngModel)]="option.label"
                  (ngModelChange)="onOptionChange()" />
              </span>
              <span>
                <ng-select
                  [items]="whenOptions"
                  bindLabel="label"
                  bindValue="value"
                  placeholder="When it sets"
                  [searchable]="true"
                  [clearable]="false"
                  [(ngModel)]="option.when"
                  (change)="onOptionChange()">
                </ng-select>
              </span>
              <span>
                <ng-select
                  [items]="timeOptions"
                  bindLabel="label"
                  bindValue="value"
                  placeholder="Time"
                  [searchable]="false"
                  [clearable]="false"
                  [(ngModel)]="option.time"
                  (change)="onOptionChange()">
                  <ng-template ng-label-tmp let-item="item"><i class="pi pi-clock mr-2 f-12"></i>{{ item.label }}</ng-template>
                </ng-select>
              </span>
              <span class="fuo-row__action">
                <button type="button" class="_circle-btn border-0" pTooltip="Remove" tooltipPosition="top" (click)="removeOption(option)">
                  <i class="pi pi-trash f-12"></i>
                </button>
              </span>
            </div>
          </div>
        </div>

        <div class="fuo-note">
          <i class="pi pi-info-circle mr-2"></i>
          "Pick date & time" is always available in the follow up menu and cannot be removed.
        </div>

        <!-- Add custom option -->
        <div class="fuo-custom">
          <p class="fuo-custom__title">
            Add a custom option
            <span class="fuo-custom__hint">Create your own follow up option.</span>
          </p>
          <div class="fuo-custom__row">
            <input
              #customLabelInput
              type="text"
              class="fuo-custom__label"
              placeholder="Option label (e.g. Next Tuesday)"
              [maxlength]="labelMaxLength"
              [class.invalidField]="customSubmitted && !customOption.label?.trim()"
              [(ngModel)]="customOption.label"
              (keydown.enter)="addCustomOption()" />
            <ng-select
              class="fuo-custom__when"
              [class.fuo-select--invalid]="customSubmitted && !customOption.when"
              [items]="whenOptions"
              bindLabel="label"
              bindValue="value"
              placeholder="When it sets"
              [searchable]="true"
              [clearable]="false"
              [(ngModel)]="customOption.when">
            </ng-select>
            <ng-select
              class="fuo-custom__time"
              [items]="timeOptions"
              bindLabel="label"
              bindValue="value"
              placeholder="Time"
              [searchable]="false"
              [clearable]="false"
              [(ngModel)]="customOption.time">
              <ng-template ng-label-tmp let-item="item"><i class="pi pi-clock mr-2 f-12"></i>{{ item.label }}</ng-template>
            </ng-select>
            <button type="button" class="_outline-primary-btn" (click)="addCustomOption()">Add option</button>
          </div>
          <small class="fuo-error" *ngIf="customSubmitted && (!customOption.label?.trim() || !customOption.when)">
            Enter a label and choose when it sets.
          </small>
        </div>
      </div>

      <div class="fuo-side">
        <!-- Preview: the same rendering the real menu uses, so the dates and times shown here are
             the ones an option would actually set. -->
        <div class="fuo-card fuo-preview">
          <p class="fuo-card__title">Preview</p>
          <p class="fuo-card__sub">This is how your follow up menu will look.</p>

          <div class="fuo-menu">
            <div class="fuo-menu__head">
              <p>Follow up</p>
              <span class="fuo-menu__close"><i class="pi pi-times"></i></span>
            </div>
            <div class="fuo-menu__item" *ngFor="let item of previewItems; trackBy: trackById">
              <span class="fuo-menu__label">{{ item.label }}</span>
              <span class="fuo-menu__time">{{ item.display }}</span>
            </div>
            <hr *ngIf="previewItems.length" />
            <p class="fuo-menu__pick"><i class="pi pi-calendar-plus mr-2"></i>Pick date & time</p>
          </div>
        </div>

        <!-- Tips -->
        <div class="fuo-tips">
          <p class="fuo-tips__title"><i class="pi pi-lightbulb mr-2"></i>Tips</p>
          <ul>
            <li>Drag and drop to reorder the options.</li>
            <li>Turn off any options you don't want to see.</li>
            <li>Default times can be changed at any time.</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
